import React, { useContext } from 'react';
import { getTranslatedString } from 'helpers/i18n';
import currency from 'currency.js';
import Stats from '../../common/Stats';
import { CurrentApplicationContext } from '../../ApplicationOverview';
import { shouldShowHoldForApplication } from '../../common/helpers';

const ApplicationOverviewStats = () => {
  const application = useContext(CurrentApplicationContext);
  const shouldShowHold = shouldShowHoldForApplication(application);

  return (
    <Stats
      items={[
        {
          title: getTranslatedString(
            'landlordPortal.applicationManagement.applicationOverview.overview.statistics.created'
          ),
          value: new Date(application.created_at),
        },
        {
          title: getTranslatedString(
            'landlordPortal.applicationManagement.applicationOverview.overview.statistics.lastUpdated'
          ),
          value: new Date(application.updated_at),
        },
        shouldShowHold && {
          title: getTranslatedString(
            'landlordPortal.applicationManagement.applicationOverview.overview.statistics.hold'
          ),
          value: currency(application.hold?.cents, { fromCents: true }),
        },
        {
          title: getTranslatedString(
            'landlordPortal.applicationManagement.applicationOverview.overview.statistics.balance'
          ),
          value: currency(application.balance?.cents, { fromCents: true }),
        },
      ].filter(Boolean)}
    />
  );
};

export default ApplicationOverviewStats;
